import {connect} from "react-redux";
import {DispatchProps, InnerProps, StateProps, Toolbar} from "../components/Toolbar";
import {RootState, ThunkDispatch} from "../types";
import {saveLocale} from "@kopjra/uikit";
import {setLocale} from "react-redux-i18n";
import {routerTools, Routes} from "../utils/router";
import {userIsAllowed} from "../utils/commons";

function mapStateToProps({i18n, user}: RootState): StateProps {
    return {
        locale: i18n.locale,
        isAllowed: userIsAllowed(user.credits),
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onChangeLocale: (locale) => {saveLocale(locale); dispatch(setLocale(locale))},
        onGoAccount: () => {routerTools.push(Routes.USER_ACCOUNT)},
        onGoToApiKeys: () => routerTools.push(Routes.API_KEYS),
        onGoToHtmlInteractions: () => routerTools.push(Routes.HTML),
        onGoToDataInteractions: () => routerTools.push(Routes.DATA),
        onGoToPdfInteractions: () => routerTools.push(Routes.PDF),
        onGoToAesInteractions: () => routerTools.push(Routes.AES),
        onGoToTimestamps: () => routerTools.push(Routes.TIMESTAMP),
        onGoToDocs: () => window.open(Routes.DOCS, "_blank"),
        onGoToValidator: () => window.open(Routes.VALIDATOR, "_blank"),
        onGoToStore: () => window.open(Routes.STORE, "_blank"),
        onGoArchCall: () => routerTools.push(Routes.CALL_ARCH),
        onGoToPdfSimpleInteractions: () => routerTools.push(Routes.PDF_SIMPLE),
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(Toolbar);
